import React, { useState } from 'react';
import Axios from 'axios';
import { plato_api_slide_path } from '@/modules/routes';
import Modal, { Footer } from '@/components/common/Modal';
import { SubmitError } from '@/components/common/Forms/Utils';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import { ISlide } from '@/components/admin/SlideShow/stores/useSlideShowStore';
import { Slide } from '../types';

interface RemoveSlideProps {
  modalManager: ModalManager;
  slide: ISlide | Slide;
}

export const RemoveSlideModal = ({ modalManager, slide }: RemoveSlideProps) => {
  const [submitting, setSubmitting] = useState(false);
  const [hasError, setHasError] = useState(false);
  const removeSlide = useSlideShowContext(state => state.removeSlide);

  const destroySlide = () => {
    setSubmitting(true);
    Axios.delete(plato_api_slide_path(slide.id))
      .then((result) => {
        if (!result.data.data.id) {
          setHasError(true);
          setSubmitting(false);
          return;
        }

        removeSlide(slide);
        setSubmitting(false);
        modalManager.close();
      })
      .catch((error) => {
        console.log(error);
        setHasError(true);
        setSubmitting(false);
      });
  };

  return (
    <Modal isOpen={modalManager.isOpen} closeModal={modalManager.close} headerText={`Delete Slide ${slide.position}`}>
      <p>Are you sure you want to delete this slide?</p>
      {hasError && <SubmitError error="Error deleting slide. Please reload the page and try again." />}
      <Footer
        primaryButtonText="Yes, delete"
        primaryButtonCallback={destroySlide}
        primaryButtonSubmit={false}
        secondaryButtonCallback={modalManager.close}
        primaryButtonClassName="btn btn--red"
        submitting={submitting}
      />
    </Modal>
  );
};

const RemoveSlide = ({ modalManager, slide } : RemoveSlideProps) => (
  <>
    <div>
      <button
        aria-label="Delete slide"
        className="dropdown-item full-size"
        type="button"
        onClick={modalManager.open}
      >
        Delete Slide
      </button>
    </div>
    <RemoveSlideModal modalManager={modalManager} slide={slide} />
  </>
);

export default RemoveSlide;
